module.exports = __webpack_public_path__ + "img/92d9f16.webp";